<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<PageHead label='请假管理' label2="修改请假记录" label3="Tips：请假超过13天需变更学员轮转状态，结业时需补足轮转时间" url="/cycle/leave/list">
			</PageHead>
			<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
				ref="form">
				<div class="m-portlet__body">
					<!--begin: Form Body -->
					<div class="form-group m-form__group row">
						<label class="col-xl-3 col-form-label">请假人：</label>
						<div class="col-xl-2" style="padding-top:8px">
							{{leavestu}}
						</div>
						<label class="col-xl-1 col-form-label">工号：</label>
						<div class="col-xl-2" style="padding-top:8px">
							{{leavestuno}}
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-3 col-form-label">请假时间：</label>
						<div class="col-xl-6">
							<el-form-item prop="leavedate"
								:rules="{required: true, message: '请假时间不能为空', trigger: 'blur'}">
								<el-date-picker v-model="form.leavedate" type="daterange" range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-3 col-form-label">请假天数：</label>
						<div class="col-xl-2">
							<el-form-item prop="leaveday"
								:rules="{required: true, message: '请假天数不能为空', trigger: 'blur'}">
								<el-input v-model="form.leaveday" placeholder="请输入请假天数"></el-input>
							</el-form-item>
						</div>
						<div class="col-xl-2 col-lg-3" style="line-height: 30px">
							<span class="m--font-warning">已累计请假天数：{{form.leavedaycount}}天</span>
						</div>
						<!-- <div class="col-xl-3 col-lg-3" style="line-height: 30px">
              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="AddPlan()">新增轮转计划</el-button>
            </div> -->
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-3 col-form-label">请假原因：</label>
						<div class="col-xl-6">
							<el-form-item prop="leavereason"
								:rules="{required: true, message: '请假原因不能为空', trigger: 'blur'}">
								<el-input v-model="form.leavereason" placeholder="请输入请假原因"></el-input>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="form-group m-form__group row">
            <label class="col-xl-3 col-form-label">状态变更：</label>
            <div class="col-xl-3" style="text-align: left;">
              <el-checkbox v-model="form.leaveischangestatus" border>变更轮转状态</el-checkbox>
            </div>
          </div> -->
					<div class="form-group m-form__group row">
						<label class="col-xl-3 col-form-label">请假凭据：</label>
						<div class="col-xl-6" style="text-align: left;vertical-align: middle;">
							<el-upload class="avatar-uploader" ref="upload" :limit="1" :action='uploadUrl'
								:show-file-list="false" :on-success="handleAvatarSuccess"
								:before-upload="beforeAvatarUpload">
								<img v-if="imageUrl" :src="imageUrl" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</div>
					</div>
					<div class="form-group m-form__group row" style="display: none;">
						<label class="col-xl-3 col-form-label">请假类型：</label>
						<div class="col-xl-2">
							<el-select v-model="form.leavetype" placeholder="请选择" style="width: 100%;">
								<el-option label="请选择" value=""></el-option>
								<el-option label="非增补" value="0"></el-option>
								<el-option label="补轮转" value="1"></el-option>
							</el-select>
						</div>
						<div class="col-xl-2" v-if="form.leavetype == '1'">
							<el-button type="primary" @click="AddPlan()">新增轮转计划</el-button>
						</div>
					</div>
					<el-row style="font-size: 16px; margin: 15px 30px 0 30px;display: none;">
						<el-col :span="24">请假轮转详细</el-col>
					</el-row>
					<div style="margin: 15px 30px 0 30px;display: none;">
						<el-table v-loading="leaveloading" :data="form.leaveTableData" stripe style="width: 100%;"
							size="medium">
							<el-table-column prop="CPSecName" label="轮转科室">
							</el-table-column>
							<el-table-column label="请假时间">
								<template slot-scope="scope">
									{{scope.row.BeginDate|formatDate}} - {{scope.row.EndDate|formatDate}}
								</template>
							</el-table-column>
							<el-table-column prop="LeaveDay" label="请假天数">
							</el-table-column>
						</el-table>
					</div>
					<div class="form-group m-form__group row" v-if="CPShow == true">
						<label class="col-xl-2 col-form-label"></label>
						<div class="col-xl-9">
							<el-table :data="form.tableData" stripe style="width: 100%" size="medium">
								<el-table-column label="轮转科室">
									<template slot-scope="scope">
										<el-select v-model="scope.row.CPSec" filterable placeholder="请选择"
											@change="secchange">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in cpsecOptions" :key="item.DictItemID"
												:label="item.DictItemName" :value="item.DictItemID">
											</el-option>
										</el-select>
									</template>
								</el-table-column>
								<el-table-column label="轮转开始时间">
									<template slot-scope="scope">
										<el-date-picker v-model="scope.row.CPBeginDate" type="date" placeholder="计划开始时间"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</template>
								</el-table-column>
								<el-table-column label="轮转结束时间">
									<template slot-scope="scope">
										<el-date-picker v-model="scope.row.CPEndDate" type="date" placeholder="计划结束时间"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
						<div class="m-form__actions m-form__actions--solid">
							<div class="row">
								<div class="col-lg-12 m--align-center">
									<SaveButton :url='saveUrl' back="/cycle/leave/list"></SaveButton>
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-dialog width="30%" title="添加轮转计划" :visible.sync="planAddVisible">
					<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
						:model="planform" ref="planform">
						<div class="m-portlet__body">
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">管理单元：</label>
								<div class="col-xl-6">
									<el-form-item prop="cpsec"
										:rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
										<el-select v-model="planform.managesec" filterable placeholder="请选择"
											@change="AddManageSecChange">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in managesecOptions" :key="item.DictItemID"
												:label="item.DictItemName" :value="item.DictItemID">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">轮转科室：</label>
								<div class="col-xl-6">
									<el-form-item prop="cpsec"
										:rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
										<el-select v-model="planform.cpsec" filterable placeholder="请选择">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in addSecOptions" :key="item.DictItemID"
												:label="item.DictItemName" :value="item.DictItemID">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">开始时间：</label>
								<div class="col-xl-6">
									<el-form-item prop="cpbegindate"
										:rules="{required: true, message: '开始时间不能为空', trigger: 'blur'}">
										<el-date-picker v-model="planform.cpbegindate" type="date" placeholder="计划开始时间"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">结束时间：</label>
								<div class="col-xl-6">
									<el-form-item prop="cpenddate"
										:rules="{required: true, message: '结束时间不能为空', trigger: 'blur'}">
										<el-date-picker v-model="planform.cpenddate" type="date" placeholder="计划结束时间"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<div class="col-xl-12 m--align-center">
									<el-button type="success" icon="el-icon-s-order" @click="PlanAdd()">新增</el-button>
								</div>
							</div>
						</div>
					</el-form>
				</el-dialog>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LeaveEdit',
		data() {
			return {
				form: {
					id: '',
					leavedate: '',
					leaveday: '',
					leavedaycount: '',
					leavereason: '',
					leaveischangestatus: false,
					leavefile: '',
					token: '',
					leavestu: '',
					tableData: [],
					leavesec: '',
					leavetype: '',
					leaveTableData: [],

				},
				planform: {
					managesec: '',
					cpsec: '',
					cpbegindate: '',
					cpenddate: ''
				},
				leavesec: '',
				leavestu: '',
				leavestuno: '',
				userid: '',
				username: '',
				rolelevel: '',
				secid: '',
				secOptions: null,
				stuOptions: null,
				saveUrl: this.$utils.Url.zpgl + '/api/APILeave/Update',
				uploadUrl: this.$utils.Url.zpgl + '/api/APILeave/UploadFile',
				imageUrl: '',
				CPShow: false,
				cpsecOptions: [],
				addSecOptions: [],
				planAddVisible: false,
				leaveloading: false
			}
		},
		watch: {
			'form.leaveday': function(newValue) {
				if (newValue * 1 >= 13) {
					this.form.leaveischangestatus = true
				} else {
					this.form.leaveischangestatus = false
				}
			},
			'form.leavedate': function(newValue) {
				var beginDate = newValue[0]
				var endDate = newValue[1]
				var days = new Date(endDate).getTime() / 1000 - parseInt(new Date(beginDate).getTime() / 1000)
				this.form.leaveday = parseInt(days / 60 / 60 / 24) + 1
			}
		},
		methods: {
			AddPlan: function() {
				this.planAddVisible = true
				this.planform.managesec = ''
				this.planform.cpsec = ''
				this.planform.cpbegindate = ''
				this.planform.cpenddate = ''
			},
			PlanAdd: function() {
				var arg = {
					CPID: '0',
					CPSec: this.planform.cpsec,
					CPBeginDate: this.planform.cpbegindate,
					CPEndDate: this.planform.cpenddate
				}
				this.form.tableData.push(arg)
				this.CPShow = true
				this.planAddVisible = false
			},
			AddManageSecChange: function() {
				this.planform.cpsec = ''
				this.addSecOptions = []
				this.AddLoadsec()
			},
			AddLoadsec: function() {
				var args = {
					token: this.form.token,
					username: this.username,
					rolelevel: this.rolelevel,
					mamagesec: this.planform.managesec
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
					that.addSecOptions = data.Data
				}, null, null, null)
			},
			secchange: function(selValue) {
				var that = this
				this.form.leavesec = selValue
				var args = {
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stusec: this.form.leavesec,
					token: this.form.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStu/List', args, function(data, model) {
					that.stuOptions = data.Data
					model.leavestu = ''
				}, null, null, this.form)
			},
			loadstu: function(secid) {
				var that = this
				var args = {
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stusec: secid,
					token: this.form.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStu/List', args, function(data) {
					that.stuOptions = data.Data
				}, null, null, null)
			},
			stuchange: function(selValue) {
				this.form.leavestu = selValue
				var args = {
					stuid: this.form.leavestu,
					token: this.form.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APILeave/StuLeaveCount', args, function(data,
				model) {
					model.leavedaycount = data.Data
				}, null, null, this.form)
			},
			beforeAvatarUpload: function(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 jpg/png 格式!')
				}
				return isJPG
			},
			handleAvatarSuccess: function(res, file) {
				if (res.Code === 0) {
					this.$refs.upload.clearFiles()
					this.imageUrl = URL.createObjectURL(file.raw)
					this.form.leavefile = res.Data
				} else {
					this.$message({
						message: res.Msg + '，' + res.Error,
						type: 'error'
					})
				}
			},
			LoadLeaveInfo: function() {
				var args = {
					id: this.form.id,
					token: this.form.token
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APILeave/ViewInfo', args, function(data, model) {
					that.leavesec = data.Data.SecName
					that.leavestu = data.Data.StuName
					that.leavestuno = data.Data.StuNo
					that.imageUrl = that.$utils.Url.zpgl + '/file/' + data.Data.LeaveFile
					model.leavesec = data.Data.LeaveSec
					model.leavestu = data.Data.LeaveStu
					model.leavedate = JSON.parse(data.Data.LeaveDate)
					model.leaveday = data.Data.LeaveDay
					model.leavereason = data.Data.LeaveReason
					model.leavedaycount = data.Data.LeaveDayCount - data.Data.LeaveDay
					model.leavetype = data.Data.LeaveType.toString()
					that.LoadCPLeaveInfo()
				}, null, null, this.form)
			},
			LoadCPLeaveInfo: function() {

			},
			LoadCPInfo: function() {
				var args = {
					token: this.form.token,
					stuid: this.form.leavestu,
					leavesec: this.form.leavesec
				}
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LeaveCPInfo', args, function(data,
					model) {
					model.tableData = data.Data
				}, null, null, this.form)
			},
			LoadManageSec: function() {
				var args = {
					token: this.form.token,
					username: this.username,
					rolelevel: this.rolelevel
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
					that.managesecOptions = data.Data
				}, null, null, null)
			},
			LoadCPSec: function() {
				var args = {
					token: this.form.token,
					username: this.username,
					rolelevel: this.rolelevel,
					mamagesec: ''
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
					that.cpsecOptions = data.Data
					that.LoadLeaveInfo()
				}, null, null, null)
			}
		},
		mounted: function() {
			this.form.token = sessionStorage.getItem('token')
			this.userid = sessionStorage.getItem('userid')
			this.username = sessionStorage.getItem('username')
			this.rolelevel = sessionStorage.getItem('rolelevel')
			this.secid = sessionStorage.getItem('secid')
			this.form.id = this.$route.params.id
			this.LoadCPSec()
			this.LoadManageSec()
		}
	}
</script>

<style scoped="scoped">
	.el-form-item {
		margin-bottom: 0px;
	}

	.el-select {
		width: 100%;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}

	/deep/.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
